<template>
    <modal
        name="new-editor-modal"
        @before-open="handleBeforeOpen"
        @before-close="isLoaded=false"
        style="z-index: 1003"
    >
        <div
            id="modal-header"
            class="w-100 px-4 py-2 position-relative"
            style="background-color: #1e7bb7"
        >
            <div class="w-100 d-flex">
                <h4 class="text-white">{{ editorTitle }}</h4>
            </div>
            <button
                type="button"
                class="close position-absolute"
                style="right: 1.25rem; top: 30%"
                @click="()=>{$modal.hide('new-editor-modal');isLoaded=false}"
                aria-label="Close"
            >
                <span aria-hidden="true" class="text-white">&times;</span>
            </button>
        </div>
        <div id="modal-body" class="p-4" style="overflow-x: auto; height: 85%; position:relative;">
            <component
                @closeAfterSave="()=>{$modal.hide('new-editor-modal');isLoaded=false}"
                ref="file"
                :tender="tender"
                :handleLoaded="handleLoaded"
                :is-editable="isEditable"
                :is="currentFile"
                v-show="false"
                :lng="lng"
            />
            <div v-if="isLoaded">
                <vue-html2pdf
                    :show-layout="true"
                    :float-layout="false"
                    :enable-download="false"
                    v-show="true"
                    id="document"
                    @beforeDownload="beforeDownload($event)"
                    :paginate-elements-by-height="900"
                    :filename="editorTitle"
                    :pdf-quality="2"
                    pdf-content-width="auto"
                    :html-to-pdf-options="{
                        margin: [5, 5, 0, 5],
                        filename: editorTitle,
                        jsPDF: { format: 'a4', orientation: 'portrait' },
                        html2canvas: {
                            scrollX: 0,
                            scrollY: 0
                        }
                    }"
                    ref="html2Pdf"
                >
                    <section slot="pdf-content" contenteditable="true" class="px-2" id="file" v-html="content"/>
                </vue-html2pdf>
            </div>
            <span v-else
                class="m-auto spinner-border spinner-border-lg position-absolute" 
                style="right: 0; top: 0; bottom: 0; left: 0;"
                role="status"
                aria-hidden="true"
            />
            <div v-if="false">
                <editor
                    v-if="isLoaded"
                    ref="file_editor"
                    v-model="content"
                    api-key="0itmwbkqro4fsojoh3hiqjwccys6v95aj8x5k2vcgczl9vam"
                    :init="init"
                />
                <span v-else
                    class="m-auto spinner-border spinner-border-lg position-absolute" 
                    style="right: 0; top: 0; bottom: 0; left: 0;"
                    role="status"
                    aria-hidden="true"
                />
            </div>
        </div>
        <div
            id="modal-footer"
            class="bg-white position-absolute w-100 p-3 text-right"
            style="bottom: 0"
        >
        
            <button v-if="action === 'save_download'" @click="save" type="button" class="btn btn-sm btn-primary mr-3">
                <span>Պահպանել</span>
            </button>
            <button :disabled="isLoading && isLoaded === false" @click="downloadPDF" type="button" class="btn btn-sm btn-primary mr-3">
                <span v-if="isLoading" class="mr-2 spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <span class="mr-2">Բեռնել</span>
                <font-awesome-icon :icon="['fas', 'download']"/>
            </button>
            <!-- <button @click="downloadDOC" type="button" class="btn btn-sm btn-primary">
                <span class="mr-2">Բեռնել DOC</span>
                <font-awesome-icon :icon="['fas', 'download']"/>
            </button> -->
        </div>
    </modal>
</template>

<script>
import VueHtml2pdf from 'vue-html2pdf'
import Editor from '@tinymce/tinymce-vue'
import download from '@/mixins/download'
import init from '@/mixins/variables'
import $ from 'jquery'
import { asBlob } from 'html-docx-js-typescript'
import { saveAs } from 'file-saver'

export default {
    name: 'NewEditorModal',
    mixins: [download, init],
    components: {
        VueHtml2pdf,
        editor: Editor,
        application_announcement_contract_security: () => import('./electronic/application_announcement_contract_security'),
        application_announcement_qualification_assurance: () => import('./electronic/application_announcement_qualification_assurance'),
        application_announcement_product_appendix1: () => import('./electronic/application_announcement_product_appendix1'),
        application_announcement_product_appendix1_1: () => import('./electronic/application_announcement_product_appendix1_1'),
        application_announcement_product_appendix1_2: () => import('./electronic/application_announcement_product_appendix1_2'),
        application_announcement_product_appendix2: () => import('./electronic/application_announcement_product_appendix2'),
        application_announcement_service_appendix1: () => import('./electronic/application_announcement_service_appendix1'),
        application_announcement_service_appendix1_1: () => import('./electronic/application_announcement_service_appendix1_1'),
        application_announcement_service_appendix2: () => import('./electronic/application_announcement_service_appendix2'),
        application_announcement_work_appendix1: () => import('./electronic/application_announcement_work_appendix1'),
        application_announcement_work_appendix1_1: () => import('./electronic/application_announcement_work_appendix1_1'),
        application_announcement_work_appendix1_2: () => import('./electronic/application_announcement_work_appendix1_2'),
        application_announcement_work_appendix2: () => import('./electronic/application_announcement_work_appendix2'),
        application_announcement_writing: () => import('./electronic/application_announcement_writing'),
        real_beneficiary_declaration_form: () => import('./electronic/real_beneficiary_declaration_form'),
        procedure_for_filling_out_the_declaration: () => import('./electronic/procedure_for_filling_out_the_declaration'),
    },
    data() {
        return {
            details: {
                contract_pages_count: 5,
                allowed_days: '',
                warranty_period: '',
                respond_period: '',
            },
            isLoading: false,
            content: '',
            editorContent: '',
            action: '',
            currentFile: '',
            lng: '',
            editorTitle: '',
            isLoaded: false,
            tender: '',
            isEditable: false,
            tenderStateId: null
        }
    },
    methods: {
        handleLoaded() {
            if(!this.isLoaded){
                setTimeout(() => {
                    this.isLoaded = true;
                    this.content = this.$refs.file.$el ? this.$refs.file.$el.innerHTML :  this.$refs.file.innerHTML
                }, 1000);
            }
        },
        handleBeforeOpen({
            params: {
                action = 'save',
                fileName,
                isEditable,
                lng = 'hy',
                editorTitle,
                tender
            },
        }) {
            this.action = action
            this.currentFile = fileName
            this.tender = tender
            this.tenderStateId = tender.tender.id
            this.isEditable = Boolean(isEditable)
            this.lng = lng
            this.editorTitle = editorTitle
            if(this.action === 'download'){
                this.is_get_details = true;
            }
        },
        save() {
            if(this.editorTitle === 'Իրական շահառուների վերաբերյալ հայտարարագրի ձև'){
                $('#document input[type=radio]').each(function () {
                    if($(this).is(":checked")){
                        $(this).attr('checked', true)
                    }
                });
                this.$refs.file.save($('#document #real-beneficiary-declaration-form').html())
            } else {
                this.$refs.file.save(document.getElementById('document').innerHTML)
            }
        },
        downloadPDF() {
            if(this.editorTitle === 'Դիմում Հայտարարություն'){
                this.$fire({
                    title: "Հարգելի գործընկեր",
                    text: "Խնդրում ենք ևս մեկ անգամ ստուգել լրացված տվյալների /մասնակցի տվյալներ, ծածկագիր, թվաբանական/ ճշտությունը հետո հաստատել և մասնակցել, քանի որ, համաձայն գնումների մասին ՀՀ օրենսդրության պահանջների, եթե գնային առաջարկում առկա է անհամապատասխանություն, ապա այդ հայտը ենթակա է մերժման։",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonText: 'Հաստատել',
                    cancelButtonText: 'Ստուգել'
                }).then(async(result) => {
                    if (result.value) {
                        this.isLoading = true;
                        $('.text-danger').removeClass("text-danger")
                        this.sendToPDFGeneration(this, $('#document').html(), this.editorTitle, () => {this.isLoading = false}, true);
                    }
                })
            } else {
                this.isLoading = true;
                $('.text-danger').removeClass("text-danger")
                this.sendToPDFGeneration(this, $('#document').html(), this.editorTitle, () => {this.isLoading = false}, true);
            }
            // this.$refs.html2Pdf.generatePdf();
            // this.$modal.hide('new-editor-modal');
            // this.isLoaded = false;
        },
        async downloadDOC() {
            const newContent = await this.$refs.file.handleBeforeDownload();
            asBlob(newContent).then(data => {
                saveAs(data, `${this.editorTitle}.docx`)
            })    
        },
        consoleLog(element){
            console.log(element)
        },
        async beforeDownload({ html2pdf, options, pdfContent }) {
            await html2pdf()
                .set(options)
                .from(pdfContent)
                .toPdf()
                .get('pdf')
                .then((pdf) => {
                    const totalPages = pdf.internal.getNumberOfPages()
                    $('.contract-pages-count').html(totalPages)
                    pdf.setPage(totalPages.length-1)
                    pdf.setFontSize(11)
                    pdf.setTextColor('#0000ff')
                    pdf.setFont('ghea')
                    pdf.text(
                        'iTender©\nwww.iTender.am',
                        pdf.internal.pageSize.getWidth() * 0.06,
                        pdf.internal.pageSize.getHeight() * 0.95
                    )
                })
                .save()
        },
    }
}
</script>
<style scoped>
  /deep/  .vm--modal {
    top: 1rem !important;
    left: unset !important;
    width: 960px !important;
    height: 95% !important;
    margin: auto;
    -webkit-border-radius: .3rem !important;
    -moz-border-radius: .3rem !important;
    border-radius: .3rem !important;
  }
</style>